import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-chart-panel-summary',
  styleUrls: ['./chart-panel-summary.component.scss'],
  template: `
    <div class="summary-container">
      <div *ngFor="let item of summary" class="row-cont">
        <div>{{ item.title }}</div>
        <div class="h6">{{ item.value }}</div>
      </div>
    </div>
  `,
})
export class ChartPanelSummaryComponent implements OnInit {
  @Input() summary: { title: string; value: number }[];
  ngOnInit(): void {}
}
